/**
 * Hook to access and modify the current theme and variant
 */

import { useContext } from 'react';
import { ThemeContext, ThemeVariant } from './ThemeContext';

export { ThemeVariant };

export const useTheme = () => {
  const context = useContext(ThemeContext);

  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }

  return context;
};
